import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtUser } from "server/models"
import { deepCopy } from "client/utils"
import {
    StoreType,
    setLifecyclePermissionsUserSelected,
} from "client/store"
import {
    UserIcon,
    TableColumn,
} from "client/components"

const UserColumns = () => {
    const selected = useSelector((state: StoreType) => state.lifecyclePermissions.users.selected)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const selectUser = (user: MtUser) => {
        let selectedCopy
        if (selected && selected.includes(user.id)) {
            selectedCopy = selected.filter((id) => (id !== user.id))
        } else {
            selectedCopy = selected ? deepCopy(selected) : []
            selectedCopy.push(user.id)
        }
        dispatch(setLifecyclePermissionsUserSelected(selectedCopy))
    }

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
            onClick: selectUser,
        },
        {
            field: "firstName",
            header: lang.name,
            sortable: true,
            cellMinWidth: "200px",
            formatter: (user: MtUser) => <UserIcon user={user} size="sm" />,
            onClick: selectUser,
        },
    ]

    return columns
}
export default UserColumns
